<!-- <kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar> -->

<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<div class="dialog-body">
  <kendo-panelbar style="margin: 20px;">
    <kendo-panelbar-item title="Summary" [expanded]="true">
      <ng-template kendoPanelBarContent>
        <table style="width: 100%">
          <thead>
            <tr>
              <th>Status</th>
              <th *ngFor="let col of columns" style="text-align: center">{{ col.label }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let status of statuses">
              <td>{{ status }}</td>

              <td *ngFor="let col of columns" style="text-align: center">
                {{ getValue(col.key, status) }}
              </td>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>


  <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
    [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
    style="height: calc(100vh - 200px); min-height: 400px; " [pageSize]="pageSize" [pageable]="true">

    <ng-template kendoGridToolbarTemplate position="top">
      <button (click)="onAddClick(  windowTitleBar)" kendoButton class="btn btn-primary">
        <fa-icon icon="circle-plus"></fa-icon> Add Student </button>
    </ng-template>

    <kendo-grid-column title="Edit" [width]="80" [locked]="true">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <button (click)="onEditClick(dataItem,  windowTitleBar)" kendoButton class="btn btn-stn-grid">
          <fa-icon icon="edit"></fa-icon>
        </button>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column title="Resend Email" [width]="80" [locked]="true">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <button (click)="onResendClick(dataItem)" kendoButton class="btn btn-stn-grid">
          <fa-icon icon="envelope"></fa-icon>
        </button>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="student" title="Student" [width]="250" [locked]="true">
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="student_institution_id" title="Student Institution ID" [width]="140">
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="placement_location" title="Placement Location" [width]="130">
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column field="supervisor" title="Supervisor" [width]="250">
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="placement_start_date" title="Placement Start Date" [width]="120" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.placement_start_date | date:'dd/MM/yyyy' }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="placement_end_date" title="Placement End Date" [width]="120" [filterable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.placement_end_date | date:'dd/MM/yyyy' }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="student_assessment_start_status" title="Student Self Assessment (Start Placement)"
      [width]="230">
      <ng-template kendoGridCellTemplate let-dataItem>

        <div class="status-cell">
          <span class="status-text">{{ dataItem.student_assessment_start_status }}</span>
          <ng-container *ngIf="dataItem.student_assessment_start_status == 'Completed'">
            <span class="actions">
              <button (click)="printReport(dataItem, 'student_start_assessment_id')" class="icon-btn">
                <fa-icon icon="print"></fa-icon>
              </button>
              <button (click)="viewAssessment(dataItem, 'student_start_assessment_id')" class="icon-btn">
                <fa-icon icon="eye"></fa-icon>
              </button>
              <button (click)="reopenAssessment(dataItem, 'student_start_assessment_id')" class="icon-btn">
                <fa-icon icon="book-open"></fa-icon>
              </button>
              <button (click)="resetAssessment(dataItem, 'student_start_assessment_id')" class="icon-btn">
                <fa-icon icon="arrows-rotate"></fa-icon>
              </button>
            </span>
          </ng-container>
        </div>

      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="student_assessment_mid_status" title="Student Self Assessment (Mid Placement)"
      [width]="230">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="status-cell">
          <span class="status-text">{{ dataItem.student_assessment_mid_status }}</span>
          <ng-container *ngIf="dataItem.student_assessment_mid_status == 'Completed'">
            <span class="actions">
              <button (click)="printReport(dataItem, 'student_mid_assessment_id')" class="icon-btn">
                <fa-icon icon="print"></fa-icon>
              </button>
              <button (click)="viewAssessment(dataItem, 'student_mid_assessment_id')" class="icon-btn">
                <fa-icon icon="eye"></fa-icon>
              </button>
              <button (click)="reopenAssessment(dataItem, 'student_mid_assessment_id')" class="icon-btn">
                <fa-icon icon="book-open"></fa-icon>
              </button>
              <button (click)="resetAssessment(dataItem, 'student_mid_assessment_id')" class="icon-btn">
                <fa-icon icon="arrows-rotate"></fa-icon>
              </button>
            </span>
          </ng-container>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="student_assessment_end_status" title="Student Self Assessment (End Placement)"
      [width]="230">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="status-cell">
          <span class="status-text">{{ dataItem.student_assessment_end_status }}</span>
          <ng-container *ngIf="dataItem.student_assessment_end_status == 'Completed'">
            <span class="actions">
              <button (click)="printReport(dataItem, 'student_end_assessment_id')" class="icon-btn">
                <fa-icon icon="print"></fa-icon>
              </button>
              <button (click)="viewAssessment(dataItem, 'student_end_assessment_id')" class="icon-btn">
                <fa-icon icon="eye"></fa-icon>
              </button>
              <button (click)="reopenAssessment(dataItem, 'student_end_assessment_id')" class="icon-btn">
                <fa-icon icon="book-open"></fa-icon>
              </button>
              <button (click)="resetAssessment(dataItem, 'student_end_assessment_id')" class="icon-btn">
                <fa-icon icon="arrows-rotate"></fa-icon>
              </button>
            </span>
          </ng-container>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="supervisor_assessment_mid_status" title="Supervisor Assessment (Mid Placement) "
      [width]="230">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="status-cell">
          <span class="status-text">{{ dataItem.supervisor_assessment_mid_status }}</span>
          <ng-container *ngIf="dataItem.supervisor_assessment_mid_status == 'Completed'">
            <span class="actions">
              <button (click)="printReport(dataItem, 'supervisor_mid_assessment_id')" class="icon-btn">
                <fa-icon icon="print"></fa-icon>
              </button>
              <button (click)="viewAssessment(dataItem, 'supervisor_mid_assessment_id')" class="icon-btn">
                <fa-icon icon="eye"></fa-icon>
              </button>
              <button (click)="reopenAssessment(dataItem, 'supervisor_mid_assessment_id')" class="icon-btn">
                <fa-icon icon="book-open"></fa-icon>
              </button>
              <button (click)="resetAssessment(dataItem, 'supervisor_mid_assessment_id')" class="icon-btn">
                <fa-icon icon="arrows-rotate"></fa-icon>
              </button>
            </span>
          </ng-container>
        </div>
        <ng-container *ngIf="dataItem.display_supervisor_mid_review_visible && dataItem.supervisor_assessment_mid_status == 'Completed'">
          <br>
          <span >Student Visible</span>
          <input type="checkbox" kendoCheckBox size="large" style="margin-left: 5px"
                 [checked]="dataItem.supervisor_mid_review_visible" (click)="setMidReviewVisible(dataItem)" />
        </ng-container>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="supervisor_assessment_end_status" title="Supervisor Assessment (End Placement) "
      [width]="230">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="status-cell">
          <span class="status-text">{{ dataItem.supervisor_assessment_end_status }}</span>
          <ng-container *ngIf="dataItem.supervisor_assessment_end_status == 'Completed'">
            <span class="actions">
              <button (click)="printReport(dataItem, 'supervisor_end_assessment_id')" class="icon-btn">
                <fa-icon icon="print"></fa-icon>
              </button>
              <button (click)="viewAssessment(dataItem, 'supervisor_end_assessment_id')" class="icon-btn">
                <fa-icon icon="eye"></fa-icon>
              </button>
              <button (click)="reopenAssessment(dataItem, 'supervisor_end_assessment_id')" class="icon-btn">
                <fa-icon icon="book-open"></fa-icon>
              </button>
              <button (click)="resetAssessment(dataItem, 'supervisor_end_assessment_id')" class="icon-btn">
                <fa-icon icon="arrows-rotate"></fa-icon>
              </button>
            </span>
          </ng-container>

        </div>
        <ng-container *ngIf="dataItem.display_supervisor_end_review_visible && dataItem.supervisor_assessment_end_status == 'Completed'">
          <br>
          <span >Student Visible</span>
          <input type="checkbox" kendoCheckBox size="large" style="margin-left: 5px"
                 [checked]="dataItem.supervisor_end_review_visible" (click)="setEndReviewVisible(dataItem)" />
        </ng-container>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column title="Activate / Deactivate" field="active" [width]="130">
      <ng-template kendoGridCellTemplate let-dataItem>
        <input type="checkbox" kendoCheckBox size="large" [checked]="dataItem.active" (click)="setActive(dataItem)" />
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
        let-filterService="filterService">
        <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
          [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate>
      <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
    </ng-template>

  </kendo-grid>
</div>
<kendo-dialog-actions>
  <button kendoButton (click)="onCancelAction()" class="btn btn-primary">Close</button>
</kendo-dialog-actions>
